import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from "@mui/material";
import MultiStep from "react-multistep";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import WestOutlinedIcon from "@mui/icons-material/WestOutlined";
import { Loading } from "../../components/ui";
import ConfirmationDialog from "./ConfirmationDialog";
import { useGetMerchantInfo, useUpdateMerchant } from "../../features/merchant/api";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { UserCard } from "../../ui-component/cards/UserCard";
import {
    ApiStatus,
    MerchantStatus,
    PaymentStatus,
    SuccessListing,
} from "./BusinessListing";
import MerchantListing from "./MerchantRegistration";
import { deleteMerchant } from "../../services/merchant";

import toast from "react-hot-toast";
import Review from "./Review";
import GeoFencingSection from "./GeoFencingSection";

export const iconStyle = {
    color: "gray", // Change this to the desired color
};

const tabs = ["Info", "Tags", "Locations"];

export const CustomerDetails = () => {
    const [steps] = useState(0);
    const [selectedTab, setSelectedTab] = useState(0);

    let { id } = useParams();
    const navigate = useNavigate();

    const merchant = useGetMerchantInfo(id);
    const updateMerchant = useUpdateMerchant(id);
    const handleDeleteMerchant = async () => {
        const res = await deleteMerchant(id);
        if (res) {
            navigate("/stores/store-orders");
        }
    };

    const regex = /^(?!(https:\/\/|http:\/\/))/; // Check if there is no http:// or https:// at the beginnin
    const { data } = merchant;

    if (merchant.isPending) return <Loading />;
    if (merchant.isError) return <div> Something went wrong</div>;

    return (
        <>
            {data && (
                <div className="bg-white rounded-md p-2">
                    <div className="flex flex-row justify-between items-center p-3">
                        <div className="flex flex-row items-center gap-2">
                            <div
                                className="cursor-pointer pr-3 flex items-center"
                                onClick={() => navigate(-1)}
                            >
                                <WestOutlinedIcon sx={{ fontSize: 26 }} />
                            </div>
                            <BusinessOutlinedIcon
                                sx={{ color: "#0ea5e9", fontSize: 26 }}
                            />
                            <h2 className="font-semibold text-xl leading-none">
                                Customer detail
                            </h2>
                        </div>
                    </div>

                    <div className="flex gap-1">
                        {tabs.map((v, i) => (
                            <div
                                className={`flex items-center gap-1.5 p-2 px-3 rounded-md cursor-pointer hover:bg-neutral-200 ${selectedTab === i && " bg-neutral-200"
                                    }`}
                                onClick={() => setSelectedTab(i)}
                                key={i}
                            >
                                {v === "Locations" && (
                                    <LocationOnOutlinedIcon
                                        sx={{ fontSize: 18 }}
                                    />
                                )}
                                {v}
                            </div>
                        ))}
                    </div>

                    {selectedTab === 0 && (
                        <div className="flex flex-col  sm:flex-row ">
                            <div className="w-full p-3 ">
                                <TableContainer component={Paper}>
                                    <Table aria-label="simple table">
                                        <TableBody>
                                            <TableRow>
                                                <TableCell
                                                    className="text-base font-medium text-gray-500"
                                                    component="th"
                                                    scope="row"
                                                >
                                                    Brand Name
                                                </TableCell>
                                                <TableCell
                                                    className="font-semibold text-base"
                                                    align="left"
                                                >
                                                    {
                                                        merchant.data
                                                            .business_name
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    className="text-base font-medium text-gray-500"
                                                    component="th"
                                                    scope="row"
                                                >
                                                    Brand Trading Name
                                                </TableCell>
                                                <TableCell
                                                    className="font-semibold text-base"
                                                    align="left"
                                                >
                                                    {
                                                        merchant.data
                                                            .brand_trading
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    className="text-base font-medium text-gray-500"
                                                    component="th"
                                                    scope="row"
                                                >
                                                    Business type
                                                </TableCell>
                                                <TableCell
                                                    className="font-semibold text-base"
                                                    align="left"
                                                >
                                                    {
                                                        merchant.data
                                                            .business_type
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    className="text-base font-medium text-gray-500"
                                                    component="th"
                                                    scope="row"
                                                >
                                                    Business Type
                                                </TableCell>
                                                <TableCell
                                                    className="font-semibold text-base"
                                                    align="left"
                                                >
                                                    {
                                                        merchant.data
                                                            .business_type
                                                    }
                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell
                                                    className="text-base font-medium text-gray-500"
                                                    component="th"
                                                    scope="row"
                                                >
                                                    NZBN
                                                </TableCell>
                                                <TableCell
                                                    className="font-semibold text-base"
                                                    align="left"
                                                >
                                                    {merchant.data.nzbn}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    className="text-base font-medium text-gray-500"
                                                    component="th"
                                                    scope="row"
                                                >
                                                    Main Industry
                                                </TableCell>
                                                <TableCell
                                                    className="font-semibold text-base"
                                                    align="left"
                                                >
                                                    {merchant.data.industry}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    className="text-base font-medium text-gray-500"
                                                    component="th"
                                                    scope="row"
                                                >
                                                    Website
                                                </TableCell>
                                                <TableCell
                                                    className="font-semibold text-base"
                                                    align="left"
                                                >
                                                    {merchant.data.url.replace(
                                                        regex,
                                                        "https://"
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    className="text-base font-medium text-gray-500"
                                                    component="th"
                                                    scope="row"
                                                >
                                                    Store
                                                </TableCell>
                                                <TableCell
                                                    className="font-semibold text-base"
                                                    align="left"
                                                >
                                                    {merchant.data.store_type}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div className="pt-5">
                                    <div className="flex flex-row justify-between align-middle items-center  border-b pb-3 border-gray-300">
                                        <p className="font-semibold text-xl text-blue-500">
                                            Contact Info
                                        </p>
                                    </div>

                                    <div className="mt-4">
                                        <UserCard
                                            name={
                                                data?.first_name +
                                                " " +
                                                data?.last_name
                                            }
                                            city={data?.city}
                                            phone={data?.phone}
                                            email={data?.email}
                                            postcode={data?.postcode}
                                            street={data?.street}
                                        />
                                    </div>
                                    {/* Delete merchant button */}
                                    <ConfirmationDialog
                                        handleDeleteMerchant={
                                            handleDeleteMerchant
                                        }
                                    />
                                </div>
                            </div>
                            <div className="bg-[#F6F9FD] w-full p-3 mb-15 rounded-lg">
                                <div>
                                    <div className="flex flex-row justify-between align-middle items-center  border-b pb-3 border-gray-300 mt-10">
                                        <p className="font-semibold text-xl text-blue-500">
                                            List to App
                                        </p>
                                    </div>
                                    <div className="ml-10">
                                        <MultiStep
                                            direction={false}
                                            title="Process"
                                            activeStep={steps}
                                            prevButton={{
                                                title: "Back",
                                                style: {
                                                    background: "red",
                                                    padding:
                                                        "10px 20px 10px 20px",
                                                    margin: "10px",
                                                    fontSize: "12px",
                                                    borderRadius: "15px",
                                                    backgroundColor: "#F53F3F",
                                                    color: "white",
                                                },
                                            }}
                                            nextButton={{
                                                title: "Forward",

                                                style: {
                                                    background: "blue",
                                                    padding:
                                                        "10px 20px 10px 20px",
                                                    margin: "10px",
                                                    fontSize: "12px",
                                                    borderRadius: "15px",
                                                    color: "white",
                                                },
                                            }}
                                            showTitles={true}
                                        >
                                            <MerchantListing title="Merchant Information" />
                                            <MerchantStatus title="Merchant Registration" />
                                            <PaymentStatus title="Payment Status" />
                                            <ApiStatus title="API status" />
                                            <SuccessListing title="listing Complete" />
                                        </MultiStep>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {selectedTab === 1 && <Review />}

                    {selectedTab === 2 && (
                        <div className="pt-4">
                            <GeoFencingSection
                                merchantId={id}
                                initialLocations={data?.locations ?? []}
                                onSaveLocations={async (locations) => {
                                    const payload = locations.map((loc) =>
                                        loc.type === "point"
                                            ? { ...loc, radiusMeters: loc.radiusMeters ?? 200 }
                                            : loc
                                    );
                                    console.log("[GEOFENCE_DEBUG] Admin saving locations", {
                                        count: payload.length,
                                        payload: payload.map((l) => ({
                                            id: l.id,
                                            name: l.name,
                                            type: l.type,
                                            coordinates: l.coordinates,
                                            radiusMeters: l.radiusMeters,
                                            hasGeometry: !!l.geometry,
                                        })),
                                    });
                                    await updateMerchant.mutateAsync({
                                        locations: payload,
                                    });
                                    toast.success("Locations saved");
                                    console.log("[GEOFENCE_DEBUG] Admin locations saved to backend OK");
                                }}
                                isSaving={updateMerchant.isPending}
                            />
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
